"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeStyles = exports.BLACKLISTED_STYLES = void 0;
var BLACKLISTED_STYLES = ['position', 'height', 'width', 'top', 'bottom', 'left', 'right', 'z-index', 'clear', 'float', 'display', 'visibility', 'opacity', 'background-image', 'white-space'];
exports.BLACKLISTED_STYLES = BLACKLISTED_STYLES;

var removeStyles = function removeStyles(_ref) {
  var node = _ref.node;

  if (node && node.style && node.style.length > 0 && node.style.removeProperty) {
    if (node.style.fontSize === '0px') {
      node.style.setProperty('font-size', '14px');
    }

    if (node.style.lineHeight === '0') {
      node.style.setProperty('line-height', 1);
    }

    if (node.style.color === 'transparent') {
      node.style.removeProperty('color');
    }

    BLACKLISTED_STYLES.forEach(function (style) {
      return node.style.removeProperty(style);
    });
    return {
      node: node
    };
  }

  return null;
};

exports.removeStyles = removeStyles;